// extracted by mini-css-extract-plugin
module.exports = {"ListOfForumsRight":"kb_a","ListOfForumsRight__brandDaysPosts":"kb_b vh_ox"};